var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsADeveloper01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 962.7 599.2",
    style: {
      enableBackground: "new 0 0 962.7 599.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#2F3050;}\n\t.st2{fill:#1A1924;}\n\t.st3{fill:#4C4F81;}\n\t.st4{fill:#222231;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#00B0C2;}\n\t.st7{fill:#E64645;}\n\t.st8{fill:#009EE2;}\n\t.st9{fill:#93C01F;}\n\t.st10{fill:#273C5C;}\n\t.st11{fill:#3D3F68;}\n\t.st12{fill:#7FC0FF;}\n\t.st13{fill:#102A54;}\n\t.st14{fill:#181936;}\n\t.st15{fill:#006663;}\n\t.st16{fill:#2A2F58;}\n\t.st17{fill:#008080;}\n\t.st18{fill:#06183C;}\n\t.st19{fill:#673438;}\n\t.st20{fill:#21263D;}\n\t.st21{fill:#F99747;}\n\t.st22{fill:#7E9BC1;}\n\t.st23{fill:#6E85B4;}\n\t.st24{fill:#9CB6E0;}\n\t.st25{fill:#A36F68;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M707.6,285.9c-1.6,15.9-3.4,31.7-4.8,47.6h36.5l-4.7-47.6H707.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "223.4,333.5 337.2,333.5 341.9,285.9 228,285.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.4,360.8c-0.9,2.2-1.7,4.4-2.4,6.7L410.4,360.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M566.1,521.7l2,10.7l1.1,5.4l6.3-2h0.2V425.5h-23.4l20.6,93C570.7,519.7,568.4,520.8,566.1,521.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "591,535.9 632.9,549 620.6,425.5 590.8,425.5 590.8,535.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.3,265.9h18c2.4-1.8,6.1-2.2,6.1-2.2l12.3-4.4l-6-28.6h-24.5l-5.6,26.1 C347.8,256.9,346.7,261.9,347.3,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M538.9,317.1c2.4-3,4.4-6.3,6-9.8c1.8-3.9,3.7-8.7,3.6-13.1c-0.3,0.2-0.5,0.2-0.8,0 c-5.8,8.7-12.3,10.5-22.7,10.6c-24.7,0.2-51.2-2.4-75.6-8.9c-7.3-2-18.1-5.4-24.9-10.1h-68.6l-26,263.9l28.9-8.2l12.5-12.2l0.9-6.2 c-10.1-4.7-17.2-9.7-17.2-9.7l13.8-37.8l0,0c-0.4-0.2-0.6-0.6-0.5-1c7.7-21.1,14.4-41.6,19-53.3c6.1-15.4,12.5-30.6,17-46.5 c3.4-11.8,7.2-22.4,13.6-30.4l0,0c3.2-4.3,8.1-8.8,15.5-11.3c4-1.5,8.5-2.5,13.6-2.9c14.7-1.1,44.7-4,59.8-4c0.5,0,0.7,0.4,0.7,0.7 l19.3-1.3C525.2,323.8,537.3,319.2,538.9,317.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 73.3,
    className: "st1",
    width: 4.2,
    height: 157.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M371.9,215.8h-0.8h-10.6v-118h10.6h0.8h61.8v82.5h5.8V82.6H209.7v138.7H376l-1.2-5.6L371.9,215.8L371.9,215.8z  M360.5,88.1h73.2v9.7h-73.2L360.5,88.1L360.5,88.1z M357.1,215.8H226.4h-0.8h-10.6v-118h10.6h0.8h130.8V215.8z M357.1,97.8H215 v-9.7h142.1V97.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "299.6,230.8 295.1,230.8 289.5,256.9 294.1,256.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.8,265.9h0.8c0-0.6,0.1-1.4,0.2-2.2c0.5-2.8,1.3-6.8,1.3-6.8h-4.6c0,0-0.5,2.6-0.9,5 c-0.7,4.1-1.6,8.6,4.1,8.6h0.9L291.8,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.2,268.2c0-1.3-0.9-2.4-2-2.4h-25.6h-0.8l1.8,4.6h3.7h20.9C319.3,270.5,320.2,269.5,320.2,268.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M365.4,265.9h-18h-29.1c1.1,0,2,1.1,2,2.4c0,1.3-0.9,2.4-2,2.4h27.9h4.6h5h7.3 C362.9,268.4,363.9,266.9,365.4,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M226.4,215.8h130.8v-118H226.4V215.8z M269,148.7v1.8h-24.7v-1.8H269z M244.4,143v-1.8h4.4v1.8H244.4z  M275.3,128.7v1.8h-25.4v-1.8H275.3z M249.9,124.7v-1.8h16.1v1.8H249.9z M269,124.7v-1.8h6.3v1.8H269z M287.1,135.4v1.8h-37.3v-1.8 H287.1z M284.2,128.7v1.8h-6.5v-1.8H284.2z M277.7,124.7v-1.8h6.5v1.8H277.7z M270.6,185.2h16.2v1.8h-16.2V185.2z M268,177.7v-1.8 h4.4v1.8H268z M261.6,158.6v1.8H253v-1.8H261.6z M253,165.3h22.6v1.8H253V165.3z M261.7,170.2v1.8h-8.5v-1.8H261.7z M253.1,201.2 h8.5v1.8h-8.5V201.2z M265.8,208.8h-12.6V207h12.6V208.8z M265.8,177.7h-12.6v-1.8h12.6V177.7z M272.3,208.8H268V207h4.4V208.8z  M280,199.2h-9.3v-1.8h9.3V199.2z M292.2,199.2h-9.5v-1.8h9.5V199.2z M292.2,193.4h-21.6v-1.8h21.6V193.4z M317.9,137.2h-28.6v-1.8 h28.6V137.2z M321.7,185.2v1.8h-12.8v-1.8H321.7z M305,185.2v1.8h-6.5v-1.8H305z M296,185.2v1.8h-6.3v-1.8H296z M317.2,199.2h-22.8 v-1.8h22.8V199.2z M324.8,199.2h-5.4v-1.8h5.4V199.2z M324.8,193.4h-30.3v-1.8h30.3V193.4z M324.8,130.5h-36.7v-1.8h36.7V130.5z  M288.1,124.7v-1.8h12.8v1.8H288.1z M282.6,118h36.7v1.8h-36.7V118z M272.2,118h6.5v1.8h-6.5V118z M269.7,119.8h-25.4V118h25.4 V119.8z M244.4,114v-1.8h4.4v1.8H244.4z M255.3,100.6h5.8v1.8h-5.8V100.6z M229.5,100.6h22.6v1.8h-22.6V100.6z M229.5,106.4h8.5 v1.8h-8.5V106.4z M229.5,112.2h12.7v1.8h-12.7V112.2z M229.5,141.2h12.7v1.8h-12.7V141.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M215,97.8v118h10.6v-118H215z M223.4,212.6h-5.8v-1.8h5.8V212.6z M223.4,206.7h-5.8v-1.8h5.8V206.7z  M223.4,200.9h-5.8v-1.8h5.8V200.9z M223.4,195.1h-5.8v-1.8h5.8V195.1z M223.4,189.3h-5.8v-1.8h5.8V189.3z M223.4,183.5h-5.8v-1.8 h5.8V183.5z M223.4,177.7h-5.8v-1.8h5.8V177.7z M223.4,171.9h-5.8v-1.8h5.8V171.9z M223.4,166.1h-5.8v-1.8h5.8V166.1z M223.4,160.3 h-5.8v-1.8h5.8V160.3z M223.4,154.5h-5.8v-1.8h5.8V154.5z M223.4,148.7h-5.8v-1.8h5.8V148.7z M223.4,143h-5.8v-1.8h5.8V143z  M223.4,137.2h-5.8v-1.8h5.8V137.2z M223.4,131.4h-5.8v-1.8h5.8V131.4z M223.4,125.6h-5.8v-1.8h5.8V125.6z M223.4,119.8h-5.8V118 h5.8V119.8z M223.4,114h-5.8v-1.8h5.8V114z M223.4,108.2h-5.8v-1.8h5.8V108.2z M223.4,102.4h-5.8v-1.8h5.8V102.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.6,
    y: 97.8,
    className: "st5",
    width: 0.8,
    height: 118
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M330.7,96.2c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3c-1.8,0-3.3,1.5-3.3,3.3C327.4,94.8,328.8,96.2,330.7,96.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M339.4,96.2c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3C336.1,94.8,337.5,96.2,339.4,96.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 348.1,
    cy: 93,
    r: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 100.6,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 106.4,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 112.2,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 118,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 123.8,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 129.6,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 135.4,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 141.2,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 147,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 152.8,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 158.6,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 164.4,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 170.2,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 176,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 181.8,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 187.6,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 193.4,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 199.2,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 205,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 210.8,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.5,
    y: 100.6,
    className: "st7",
    width: 22.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 165.3,
    className: "st7",
    width: 22.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 158.6,
    className: "st7",
    width: 8.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.5,
    y: 106.4,
    className: "st6",
    width: 8.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.5,
    y: 112.2,
    className: "st6",
    width: 12.7,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.4,
    y: 112.2,
    className: "st8",
    width: 4.4,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.1,
    y: 170.2,
    className: "st6",
    width: 8.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.1,
    y: 176,
    className: "st6",
    width: 12.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 176,
    className: "st8",
    width: 4.4,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.1,
    y: 201.2,
    className: "st6",
    width: 8.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.1,
    y: 207,
    className: "st6",
    width: 12.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 207,
    className: "st8",
    width: 4.4,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.5,
    y: 141.2,
    className: "st6",
    width: 12.7,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.4,
    y: 141.2,
    className: "st8",
    width: 4.4,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.3,
    y: 100.6,
    className: "st9",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.4,
    y: 148.7,
    className: "st9",
    width: 24.7,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.4,
    y: 118,
    className: "st5",
    width: 25.4,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.6,
    y: 118,
    className: "st5",
    width: 36.7,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.2,
    y: 118,
    className: "st5",
    width: 6.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.9,
    y: 128.7,
    className: "st5",
    width: 25.4,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.1,
    y: 128.7,
    className: "st5",
    width: 36.7,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.7,
    y: 128.7,
    className: "st5",
    width: 6.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.9,
    y: 122.9,
    className: "st5",
    width: 16.2,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269,
    y: 122.9,
    className: "st5",
    width: 6.3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.1,
    y: 122.9,
    className: "st5",
    width: 12.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.7,
    y: 122.9,
    className: "st5",
    width: 6.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.9,
    y: 135.4,
    className: "st5",
    width: 37.3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.3,
    y: 135.4,
    className: "st5",
    width: 28.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.6,
    y: 185.2,
    className: "st5",
    width: 16.2,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.8,
    y: 185.2,
    className: "st5",
    width: 6.3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.8,
    y: 185.2,
    className: "st5",
    width: 12.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.5,
    y: 185.2,
    className: "st5",
    width: 6.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.6,
    y: 191.6,
    className: "st5",
    width: 21.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.5,
    y: 191.6,
    className: "st5",
    width: 30.3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.6,
    y: 197.4,
    className: "st5",
    width: 9.3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.7,
    y: 197.4,
    className: "st5",
    width: 9.5,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.3,
    y: 197.4,
    className: "st5",
    width: 5.4,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.5,
    y: 197.4,
    className: "st5",
    width: 22.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M371.9,97.8v82.5h61.8V97.8C433.7,97.8,371.9,97.8,371.9,97.8z M399.4,118h16.9v1.8h-16.9V118z M407.8,122.9 v1.8h-5.9v-1.8H407.8z M397.2,124.7v-1.8h3v1.8H397.2z M400.2,128.7v1.8h-3v-1.8H400.2z M394.6,118h3v1.8h-3V118z M396,128.7v1.8 h-11.7v-1.8H396z M384.4,124.7v-1.8h7.4v1.8H384.4z M393.1,124.7v-1.8h2.9v1.8H393.1z M393.5,119.8h-11.7V118h11.7V119.8z  M383.9,141.2v1.8h-2v-1.8H383.9z M381.9,114v-1.8h2v1.8H381.9z M386.9,100.6h2.6v1.8h-2.6V100.6z M375,100.6h10.3v1.8H375V100.6z  M375,106.4h3.9v1.8H375V106.4z M380.9,143h-5.8v-1.8h5.8V143z M380.9,114h-5.8v-1.8h5.8V114z M381.9,148.7h11.3v1.8h-11.3V148.7z  M389.8,158.6v1.8h-4v-1.8H389.8z M391.7,177.7h-5.8v-1.8h5.8V177.7z M385.9,171.9v-1.8h3.9v1.8H385.9z M394.7,177.7h-2v-1.8h2 V177.7z M396.2,167h-10.4v-1.8h10.3L396.2,167L396.2,167z M401.5,137.2h-17.1v-1.8h17.1V137.2z M415.6,137.2h-13.1v-1.8h13.1V137.2 z M401.9,130.5v-1.8h16.9v1.8H401.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M360.5,97.8v118h10.6v-17.4l-2.2-10.4v1.4h-5.8v-1.8h5.7l-0.8-4h-4.9v-1.8h4.5l-0.3-1.5h2.4h1.5V97.8 L360.5,97.8L360.5,97.8z M368.9,212.6h-5.8v-1.8h5.8V212.6z M368.9,206.7h-5.8v-1.8h5.8V206.7z M368.9,200.9h-5.8v-1.8h5.8V200.9z  M368.9,193.4v1.8h-5.8v-1.8H368.9z M368.9,177.7h-5.8v-1.8h5.8V177.7z M368.9,171.9h-5.8v-1.8h5.8V171.9z M368.9,166.1h-5.8v-1.8 h5.8V166.1z M368.9,160.3h-5.8v-1.8h5.8V160.3z M368.9,154.5h-5.8v-1.8h5.8V154.5z M368.9,148.7h-5.8v-1.8h5.8V148.7z M368.9,143 h-5.8v-1.8h5.8V143z M368.9,137.2h-5.8v-1.8h5.8V137.2z M368.9,131.4h-5.8v-1.8h5.8V131.4z M368.9,125.6h-5.8v-1.8h5.8V125.6z  M368.9,119.8h-5.8V118h5.8V119.8z M368.9,114h-5.8v-1.8h5.8V114z M368.9,108.2h-5.8v-1.8h5.8V108.2z M368.9,102.4h-5.8v-1.8h5.8 V102.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "374.7,215.8 371.9,202.1 371.9,215.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.1,
    y: 97.8,
    className: "st5",
    width: 0.8,
    height: 82.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "371.9,215.8 371.9,202.1 371.1,198.4 371.1,215.8  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 407.3,
    cy: 92.9,
    rx: 3.3,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M416,89.6c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3C419.2,91.1,417.8,89.6,416,89.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 424.6,
    cy: 93,
    r: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 100.6,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 106.4,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 112.2,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 118,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 123.8,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 129.6,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 135.4,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 141.2,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 147,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 152.8,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 158.6,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 164.4,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 170.2,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 176,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "363.1,183.5 368,183.5 367.6,181.8 363.1,181.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "363.1,189.3 368.9,189.3 368.9,188 368.8,187.6 363.1,187.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 193.4,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 199.2,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 205,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.1,
    y: 210.8,
    className: "st5",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 100.6,
    className: "st7",
    width: 10.3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.8,
    y: 165.3,
    className: "st7",
    width: 10.3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.8,
    y: 158.6,
    className: "st7",
    width: 3.9,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 106.4,
    className: "st6",
    width: 3.9,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 112.2,
    className: "st6",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.9,
    y: 112.2,
    className: "st8",
    width: 2,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.9,
    y: 170.2,
    className: "st6",
    width: 3.9,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.9,
    y: 176,
    className: "st6",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.7,
    y: 176,
    className: "st8",
    width: 2,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 141.2,
    className: "st6",
    width: 5.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.9,
    y: 141.2,
    className: "st8",
    width: 2,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.9,
    y: 100.6,
    className: "st9",
    width: 2.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.9,
    y: 148.7,
    className: "st9",
    width: 11.3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.9,
    y: 118,
    className: "st5",
    width: 11.7,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.4,
    y: 118,
    className: "st5",
    width: 16.9,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.6,
    y: 118,
    className: "st5",
    width: 3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.4,
    y: 128.7,
    className: "st5",
    width: 11.7,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.9,
    y: 128.7,
    className: "st5",
    width: 16.9,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.2,
    y: 128.7,
    className: "st5",
    width: 3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.4,
    y: 122.9,
    className: "st5",
    width: 7.4,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.1,
    y: 122.9,
    className: "st5",
    width: 2.9,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.9,
    y: 122.9,
    className: "st5",
    width: 5.9,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.2,
    y: 122.9,
    className: "st5",
    width: 3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.4,
    y: 135.4,
    className: "st5",
    width: 17.1,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.5,
    y: 135.4,
    className: "st5",
    width: 13.1,
    height: 1.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "386.1,258.5 369.6,180.4 367.3,180.4 367.6,181.8 368,183.5 368.8,187.6 368.9,188 371.1,198.4  371.9,202.1 374.7,215.8 375.9,221.3 377.9,230.8 383.9,259.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M383.5,193.8h5.7h0.1H383.5l-1.1-5.2h73.6l1,5.2h-67.5l0,0H457l12,62.5h-65.5l10,2.8c0,0,0.9,0.1,2.4,0.4l0,0 l33.2-0.5c0,0,1.4,0.4,3.8,0.8h30.5c4.4-0.7,9-1.8,13.7-3.4h-20.7l-0.4,0.1v-0.1h-4.5L459,193.9h5.7h0.1H459l-1-5.2h37.5l1.3,5.2 h-31.8l0,0h31.8l12.1,57.6c0.1-0.1,0.2-0.1,0.3-0.1l-0.1-0.1c-0.1-0.5,0.1-0.8,0.5-1c1.7-0.5,3.4-1,4.9-1.4l-13.5-64.1H376.6 l15.1,71.7l4.6-1.6L383.5,193.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M457,193.8h-67.5l12.9,62.1l1.1,0.3H469L457,193.8z M448,240.9h-6.5l-0.2-0.9h6.5L448,240.9z M443.7,211h-19 l-0.2-0.9h19L443.7,211z M422,229.5l0.2,0.9h-11.6l-0.2-0.9H422z M409.9,226.9l-0.2-0.9h4.4l0.2,0.9H409.9z M426.1,214.5l-0.2-0.9 h14.7l0.2,0.9H426.1z M402.6,201.4l0.2,0.9h-2.3l-0.2-0.9H402.6z M414,204.5l0.2,0.9h-13.1l-0.2-0.9H414z M417.4,207l0.2,0.9h-3.3 l-0.2-0.9H417.4z M412.6,207l0.2,0.9h-8.3l-0.2-0.9H412.6z M418.1,210.1l0.2,0.9h-13.1l-0.2-0.9H418.1z M424.9,213.6l0.2,0.9h-19.1 l-0.2-0.9H424.9z M418.9,208l-0.2-0.9h3.4l0.2,0.9H418.9z M422.6,210.1l0.2,0.9h-3.4l-0.2-0.9H422.6z M424,207h6.6l0.2,0.9h-6.6 L424,207z M439.5,204.5l0.2,0.9h-19l-0.2-0.9H439.5z M415.4,205.4l-0.2-0.9h3.4l0.2,0.9H415.4z M407.7,195.2l0.2,0.9h-3l-0.2-0.9 H407.7z M391.3,195.2H403l0.2,0.9h-11.7L391.3,195.2z M391.9,198.3h4.4l0.2,0.9h-4.4L391.9,198.3z M399.1,201.4l0.2,0.9h-6.5 l-0.2-0.9H399.1z M405.8,217.6h-2.3l-0.2-0.9h2.3L405.8,217.6z M402.5,217.6h-6.5l-0.2-0.9h6.5L402.5,217.6z M404.3,220.7H417 l0.2,0.9h-12.7L404.3,220.7z M439.4,240.9H436l-0.2-0.9h3.4L439.4,240.9z M434.8,240.9h-3.2l-0.2-0.9h3.2L434.8,240.9z  M421.7,236.1h-2.3l-0.2-0.9h2.3L421.7,236.1z M411.1,232h4.4l0.2,0.9h-4.4L411.1,232z M411.7,235.1h6.5l0.2,0.9h-6.5L411.7,235.1z  M414.4,248.5h4.4l0.2,0.9h-4.4L414.4,248.5z M415.2,252.5l-0.2-0.9h6.4l0.2,0.9H415.2z M421.6,240h8.3l0.2,0.9h-8.3L421.6,240z  M422.3,243.4h11.1l0.2,0.9h-11.1L422.3,243.4z M422.8,252.5l-0.2-0.9h2.3l0.2,0.9H422.8z M423.1,247.5l-0.2-0.9h4.8l0.2,0.9H423.1 z M429.3,247.5l-0.2-0.9h4.9l0.2,0.9H429.3z M434.6,243.4h15.5l0.2,0.9h-15.5L434.6,243.4z M435.3,247.5l-0.2-0.9h11.6l0.2,0.9 H435.3z M448,247.5l-0.2-0.9h2.8l0.2,0.9H448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M388.9,193.9l0.4-0.1h-5.7l12.7,61.2l1.3-0.5l-0.2-0.9h3l0.2,0.9h-3l4.1,1.2L388.9,193.9z M390.3,205.4h-3 l-0.2-0.9h3L390.3,205.4z M389.7,202.3h-3l-0.2-0.9h3L389.7,202.3z M385.1,195.2h3l0.2,0.9h-3L385.1,195.2z M388.9,198.3l0.2,0.9 h-3l-0.2-0.9H388.9z M388.4,210.6h3l0.2,0.9h-3L388.4,210.6z M392.2,214.5h-3l-0.2-0.9h3L392.2,214.5z M390.9,208.5h-3l-0.2-0.9h3 L390.9,208.5z M389.7,216.7h3l0.2,0.9h-3L389.7,216.7z M390.5,220.7l-0.2-0.9h3l0.2,0.9H390.5z M395.4,230h-3l-0.2-0.9h3L395.4,230 z M394.8,226.9h-3l-0.2-0.9h3L394.8,226.9z M390.9,222.9h3l0.2,0.9h-3L390.9,222.9z M392.9,232h3l0.2,0.9h-3L392.9,232z  M399.8,251.5h-3l-0.2-0.9h3L399.8,251.5z M399.2,248.4h-3l-0.2-0.9h3L399.2,248.4z M398.6,245.3h-3l-0.2-0.9h3L398.6,245.3z  M397.9,242.2h-3l-0.2-0.9h3L397.9,242.2z M397.3,239.1h-3l-0.2-0.9h3L397.3,239.1z M393.7,236.1l-0.2-0.9h3l0.2,0.9H393.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "389.6,193.8 389.6,193.8 389.3,193.8 389.2,193.8 388.9,193.9 401.6,255.6 402.5,255.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M443.3,192.9c0.9,0,1.5-0.8,1.4-1.7c-0.2-1-1.1-1.7-2.1-1.7s-1.5,0.8-1.4,1.7 C441.4,192.1,442.3,192.9,443.3,192.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M447.7,192.9c0.9,0,1.5-0.8,1.4-1.7c-0.2-1-1.1-1.7-2.1-1.7c-0.9,0-1.5,0.8-1.4,1.7 C445.9,192.1,446.8,192.9,447.7,192.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M452.2,192.9c0.9,0,1.5-0.8,1.4-1.7c-0.2-1-1.1-1.7-2.1-1.7c-0.9,0-1.5,0.8-1.4,1.7 C450.3,192.1,451.2,192.9,452.2,192.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "388.2,195.2 385.1,195.2 385.4,196.1 388.4,196.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "389,199.2 388.9,198.3 385.8,198.3 386.1,199.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "386.7,202.3 389.7,202.3 389.5,201.4 386.4,201.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "387.3,205.4 390.3,205.4 390.1,204.5 387.1,204.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "388,208.5 390.9,208.5 390.8,207.5 387.8,207.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "391.4,210.6 388.4,210.6 388.6,211.6 391.6,211.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "389.2,214.5 392.2,214.5 392,213.6 389,213.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "392.7,216.7 389.7,216.7 389.9,217.6 392.9,217.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "390.3,219.8 390.5,220.7 393.5,220.7 393.3,219.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "393.9,222.9 390.9,222.9 391.1,223.8 394.1,223.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "391.8,226.9 394.8,226.9 394.6,226 391.6,226  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "392.4,230 395.4,230 395.2,229 392.2,229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "395.8,232 392.9,232 393,233 396,233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "393.5,235.1 393.7,236.1 396.7,236.1 396.5,235.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "394.3,239.1 397.3,239.1 397.1,238.2 394.1,238.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "394.9,242.2 397.9,242.2 397.7,241.3 394.8,241.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "395.6,245.3 398.6,245.3 398.4,244.4 395.4,244.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "396.2,248.4 399.2,248.4 399,247.5 396,247.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "396.8,251.5 399.8,251.5 399.7,250.5 396.7,250.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "400.3,253.5 397.3,253.5 397.5,254.5 400.5,254.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "403,195.2 391.3,195.2 391.6,196.1 403.2,196.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "422.2,230.4 422,229.5 410.4,229.5 410.6,230.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "409.7,226 409.9,226.9 414.3,226.9 414.2,226  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "396.4,198.3 391.9,198.3 392.2,199.2 396.6,199.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "399.4,202.3 399.1,201.4 392.6,201.4 392.9,202.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "402.7,202.3 402.6,201.4 400.3,201.4 400.5,202.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "415.4,232 411.1,232 411.3,233 415.6,233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "418.1,235.1 411.7,235.1 411.9,236.1 418.3,236.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "419.5,236.1 421.7,236.1 421.5,235.1 419.3,235.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "418.8,248.5 414.4,248.5 414.6,249.5 419,249.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "415.1,251.5 415.2,252.5 421.7,252.5 421.5,251.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "422.6,251.5 422.8,252.5 425,252.5 424.9,251.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "395.9,217.6 402.5,217.6 402.3,216.7 395.8,216.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "403.6,217.6 405.8,217.6 405.6,216.7 403.5,216.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "407.9,196.1 407.7,195.2 404.7,195.2 404.9,196.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "417.2,221.7 416.9,220.7 404.3,220.7 404.5,221.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "414.2,205.4 414,204.5 400.9,204.5 401.1,205.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "439.7,205.4 439.5,204.5 420.6,204.5 420.8,205.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "415.2,204.5 415.4,205.4 418.8,205.4 418.6,204.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "418.2,211 418.1,210.1 404.9,210.1 405.1,211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "424.6,210.1 424.8,211 443.7,211 443.5,210.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "422.8,211 422.6,210.1 419.2,210.1 419.4,211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "412.9,208 412.6,207 404.3,207 404.5,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "417.6,208 417.4,207 414.2,207 414.3,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "430.6,207 424,207 424.2,208 430.8,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "418.6,207 418.9,208 422.2,208 422,207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "425,214.5 424.9,213.6 405.6,213.6 405.8,214.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "440.6,213.6 425.9,213.6 426.1,214.5 440.8,214.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "429.9,240 421.6,240 421.8,240.9 430.1,240.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "431.6,240.9 434.8,240.9 434.7,240 431.4,240  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "441.4,240.9 448,240.9 447.8,240 441.2,240  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "436,240.9 439.4,240.9 439.2,240 435.8,240  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "433.4,243.4 422.3,243.4 422.5,244.4 433.6,244.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "450.1,243.4 434.6,243.4 434.7,244.4 450.2,244.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "423,246.5 423.1,247.5 427.9,247.5 427.8,246.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "429.1,246.5 429.3,247.5 434.2,247.5 434,246.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "447.8,246.5 448,247.5 450.8,247.5 450.6,246.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "435.1,246.5 435.3,247.5 447,247.5 446.8,246.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M464.5,193.8h-5.7l12.6,62.5h4.5l-11.8-62.4L464.5,193.8z M460.4,195.2h3l0.2,0.9h-3L460.4,195.2z  M474.7,254.5h-3l-0.2-0.9h3L474.7,254.5z M474.2,251.5h-3l-0.2-0.9h3L474.2,251.5z M473.6,248.4h-3l-0.2-0.9h3L473.6,248.4z  M473,245.3h-3l-0.2-0.9h3L473,245.3z M472.4,242.2h-3l-0.2-0.9h3L472.4,242.2z M471.8,239.1h-3l-0.2-0.9h3L471.8,239.1z  M471.2,236.1h-3l-0.2-0.9h3L471.2,236.1z M470.7,233h-3l-0.2-0.9h3L470.7,233z M470,230h-3l-0.2-0.9h3L470,230z M469.5,226.9h-3 l-0.2-0.9h3L469.5,226.9z M468.8,223.8h-3l-0.2-0.9h3L468.8,223.8z M468.3,220.7h-3l-0.2-0.9h3L468.3,220.7z M467.7,217.6h-3 l-0.2-0.9h3L467.7,217.6z M467.1,214.5h-3l-0.2-0.9h3L467.1,214.5z M466.6,211.6h-3l-0.2-0.9h3L466.6,211.6z M465.9,208.5h-3 l-0.2-0.9h3L465.9,208.5z M465.4,205.4h-3l-0.2-0.9h3L465.4,205.4z M464.8,202.3h-3l-0.2-0.9h3L464.8,202.3z M464.2,199.2h-3 l-0.2-0.9h3L464.2,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M496.7,193.8h-31.8l11.9,62.4l-0.4,0.1H497c3.8-1.3,7.8-2.9,11.7-4.9L496.7,193.8z M498.3,244.4h-7.2 l-0.2-0.9h7.2L498.3,244.4z M490.5,243.4l0.2,0.9h-5.1l-0.2-0.9H490.5z M485,240.9l-0.2-0.9h3.8l0.2,0.9H485z M489.4,240.9 l-0.2-0.9h1.5l0.2,0.9H489.4z M484.4,214.5l-0.2-0.9h6.7l0.2,0.9H484.4z M484.4,236.1h-1l-0.2-0.9h1L484.4,236.1z M496.8,240 l0.2,0.9h-3l-0.2-0.9H496.8z M493,240.9h-1.5l-0.2-0.9h1.5L493,240.9z M492.1,211h-8.7l-0.2-0.9h8.7L492.1,211z M483.7,213.6 l0.2,0.9h-8.8l-0.2-0.9H483.7z M474.5,211l-0.2-0.9h6l0.2,0.9H474.5z M480.8,210.1h1.5l0.2,0.9H481L480.8,210.1z M482.7,207h3 l0.2,0.9h-3L482.7,207z M489.6,204.5l0.2,0.9h-8.7l-0.2-0.9H489.6z M481.8,207l0.2,0.9h-1.5l-0.2-0.9H481.8z M480,204.5l0.2,0.9 h-1.5l-0.2-0.9H480z M479.7,207l0.2,0.9h-1.5l-0.2-0.9H479.7z M478.1,205.4h-6l-0.2-0.9h6L478.1,205.4z M474.1,195.2l0.2,0.9h-1.4 l-0.2-0.9H474.1z M472.5,202.3h-1l-0.2-0.9h1L472.5,202.3z M466.6,195.2h5.3l0.2,0.9h-5.3L466.6,195.2z M467.2,198.3h2l0.2,0.9h-2 L467.2,198.3z M467.7,201.4h3l0.2,0.9h-3L467.7,201.4z M470.8,217.6l-0.2-0.9h3l0.2,0.9H470.8z M473.6,207h3.8l0.2,0.9h-3.8 L473.6,207z M474.2,216.7h1l0.2,0.9h-1L474.2,216.7z M475.1,221.7l-0.2-0.9h5.8l0.2,0.9H475.1z M478,226h2l0.2,0.9h-2L478,226z  M478.6,229.5h5.3l0.2,0.9h-5.3L478.6,229.5z M479.2,232h2l0.2,0.9h-2L479.2,232z M479.7,235.1h3l0.2,0.9h-3L479.7,235.1z  M482.3,248.5h2l0.2,0.9h-2L482.3,248.5z M483,252.5l-0.2-0.9h3l0.2,0.9H483z M486.5,252.5l-0.2-0.9h1l0.2,0.9H486.5z M486.2,247.5 l-0.2-0.9h2.2l0.2,0.9H486.2z M489,247.5l-0.2-0.9h2.3l0.2,0.9H489z M491.8,247.5l-0.2-0.9h5.3l0.2,0.9H491.8z M497.4,246.5h1.3 l0.2,0.9h-1.3L497.4,246.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "464.8,193.8 464.8,193.8 464.6,193.8 464.5,193.8 464.1,193.9 476,256.3 476,256.3 476.4,256.3  476.7,256.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M357.1,97.8v-9.7H215v9.7H357.1z M348.1,89.6c1.8,0,3.3,1.5,3.3,3.3c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3 C344.7,91.1,346.2,89.6,348.1,89.6z M339.4,89.6c1.8,0,3.3,1.5,3.3,3.3c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3 C336.1,91.1,337.5,89.6,339.4,89.6z M330.7,89.6c1.8,0,3.3,1.5,3.3,3.3c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3 C327.4,91.1,328.8,89.6,330.7,89.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M433.7,88.1h-73.2v9.7h73.2V88.1z M407.3,96.2c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3 C410.5,94.8,409.1,96.2,407.3,96.2z M416,96.2c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3 C419.2,94.8,417.8,96.2,416,96.2z M424.6,96.2c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3 C427.9,94.8,426.4,96.2,424.6,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M483.3,259.6h-30.5C458.6,260.5,469.9,261.8,483.3,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M505.5,180.4h-2.4H447V73.3H202.3h-0.1v157.5h0.1h92.9h4.6l-5.6,26.1c0,0-0.8,4-1.3,6.8 c-0.2,0.8-0.2,1.5-0.2,2.2h25.6h29.1c-0.6-4,0.5-9,0.5-9l5.6-26.1h24.5l-2-9.4H209.7V82.6h229.9v97.7h-5.8h-61.8h-0.8h-1.5 l16.4,78.3l5.6-2l-15.1-71.7h124.3l13.4,63.9c1.7-0.4,3.3-0.7,4.8-0.9c0.1-0.5,0.1-0.9,0.2-1.5L505.5,180.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M382.5,188.6l1.1,5.2h5.8h0.3h67.5l-1-5.2H382.5z M443.3,192.9c-0.9,0-1.9-0.8-2.1-1.7 c-0.2-1,0.5-1.7,1.4-1.7c0.9,0,1.9,0.8,2.1,1.7C444.8,192.1,444.2,192.9,443.3,192.9z M447.7,192.9c-0.9,0-1.9-0.8-2.1-1.7 c-0.2-1,0.5-1.7,1.4-1.7s1.9,0.8,2.1,1.7C449.3,192.1,448.7,192.9,447.7,192.9z M452.2,192.9c-0.9,0-1.9-0.8-2.1-1.7 c-0.2-1,0.5-1.7,1.4-1.7c0.9,0,1.9,0.8,2.1,1.7C453.8,192.1,453.1,192.9,452.2,192.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M457.9,188.6l1,5.2h5.8h0.3h31.8l-1.3-5.2H457.9z M482.8,192.9c-0.9,0-1.8-0.8-2-1.7c-0.2-1,0.5-1.7,1.4-1.7 c0.9,0,1.8,0.8,2,1.7C484.4,192.1,483.8,192.9,482.8,192.9z M487.3,192.9c-0.9,0-1.8-0.8-2-1.7c-0.2-1,0.5-1.7,1.4-1.7 c0.9,0,1.8,0.8,2,1.7C488.9,192.1,488.3,192.9,487.3,192.9z M491.8,192.9c-0.9,0-1.8-0.8-2-1.7c-0.2-1,0.5-1.7,1.4-1.7 s1.8,0.8,2,1.7C493.4,192.1,492.8,192.9,491.8,192.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M482.8,192.9c0.9,0,1.5-0.8,1.4-1.7c-0.2-1-1.1-1.7-2-1.7c-0.9,0-1.5,0.8-1.4,1.7 C481,192.1,481.9,192.9,482.8,192.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M487.3,192.9c0.9,0,1.5-0.8,1.4-1.7c-0.2-1-1.1-1.7-2-1.7c-0.9,0-1.5,0.8-1.4,1.7 C485.5,192.1,486.4,192.9,487.3,192.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M491.8,192.9c0.9,0,1.5-0.8,1.4-1.7c-0.2-1-1.1-1.7-2-1.7s-1.5,0.8-1.4,1.7C490,192.1,490.9,192.9,491.8,192.9 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "463.4,195.2 460.4,195.2 460.6,196.1 463.6,196.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "461,198.3 461.2,199.2 464.2,199.2 464,198.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "461.8,202.3 464.8,202.3 464.6,201.4 461.6,201.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "462.4,205.4 465.4,205.4 465.2,204.5 462.2,204.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "462.9,208.5 465.9,208.5 465.8,207.5 462.8,207.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "463.6,211.6 466.6,211.6 466.4,210.6 463.4,210.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "464.1,214.5 467.1,214.5 466.9,213.6 463.9,213.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "464.8,217.6 467.7,217.6 467.6,216.7 464.6,216.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "465.3,220.7 468.3,220.7 468.1,219.8 465.1,219.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "465.9,223.8 468.8,223.8 468.7,222.9 465.8,222.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "466.5,226.9 469.5,226.9 469.3,226 466.3,226  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "467.1,230 470,230 469.8,229 466.9,229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "467.7,233 470.7,233 470.5,232 467.5,232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "468.2,236.1 471.2,236.1 471,235.1 468.1,235.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "468.8,239.1 471.8,239.1 471.6,238.2 468.7,238.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "469.4,242.2 472.4,242.2 472.2,241.3 469.2,241.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "470,245.3 473,245.3 472.8,244.4 469.8,244.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "470.6,248.4 473.6,248.4 473.4,247.5 470.4,247.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "471.2,251.5 474.2,251.5 474,250.5 471,250.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "471.7,254.5 474.7,254.5 474.5,253.5 471.6,253.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "471.9,195.2 466.6,195.2 466.8,196.1 472.1,196.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "484,229.5 478.6,229.5 478.8,230.4 484.2,230.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "480,226 478,226 478.2,226.9 480.2,226.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "469.2,198.3 467.2,198.3 467.4,199.2 469.4,199.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "470.7,201.4 467.7,201.4 467.9,202.3 470.9,202.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "471.5,202.3 472.5,202.3 472.3,201.4 471.3,201.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "481.2,232 479.2,232 479.4,233 481.4,233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "482.7,235.1 479.7,235.1 479.9,236.1 482.9,236.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "483.3,235.1 483.4,236.1 484.4,236.1 484.3,235.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "484.3,248.5 482.3,248.5 482.4,249.5 484.4,249.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "482.8,251.5 483,252.5 486,252.5 485.8,251.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "486.3,251.5 486.5,252.5 487.5,252.5 487.3,251.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "470.7,216.7 470.8,217.6 473.8,217.6 473.6,216.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "475.2,216.7 474.2,216.7 474.4,217.6 475.4,217.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "474.3,196.1 474.1,195.2 472.7,195.2 472.9,196.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "480.8,220.7 474.9,220.7 475.1,221.7 481,221.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "472,205.4 478.1,205.4 477.9,204.5 471.8,204.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "489.8,205.4 489.6,204.5 480.9,204.5 481.1,205.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "480.2,205.4 480,204.5 478.4,204.5 478.6,205.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "474.3,210.1 474.5,211 480.4,211 480.3,210.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "483.4,211 492.1,211 492,210.1 483.3,210.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "482.3,210.1 480.8,210.1 481,211 482.5,211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "477.5,207 473.6,207 473.8,208 477.7,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "479.9,208 479.7,207 478.2,207 478.4,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "485.8,207 482.7,207 482.9,208 486,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "482,208 481.8,207 480.3,207 480.4,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "483.9,214.5 483.7,213.6 474.9,213.6 475.1,214.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "491,213.6 484.3,213.6 484.4,214.5 491.1,214.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "484.8,240 485,240.9 488.8,240.9 488.6,240  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "490.8,240 489.2,240 489.4,240.9 491,240.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "496.9,240.9 496.8,240 493.8,240 494,240.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "491.5,240.9 493,240.9 492.9,240 491.3,240  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "490.7,244.4 490.5,243.4 485.4,243.4 485.6,244.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "491.2,244.4 498.3,244.4 498.1,243.4 491.1,243.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "486,246.5 486.2,247.5 488.3,247.5 488.2,246.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "488.9,246.5 489,247.5 491.2,247.5 491.1,246.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "498.8,246.5 497.4,246.5 497.6,247.5 498.9,247.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "491.6,246.5 491.8,247.5 497.1,247.5 496.9,246.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M734.6,285.9h13.9v-15.3h-39.3c-0.5,5.1-1.1,10.2-1.6,15.3H734.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M418.2,278.2c-0.4-2.3-0.6-4.3-0.8-6c-0.8-0.5-1.6-1.1-2.5-1.6h-28.4h-8h-15.4h-7.3v15.3h68.6 C421,283.6,418.6,281,418.2,278.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "341.9,285.9 355.8,285.9 355.8,270.5 350.8,270.5 346.2,270.5 318.2,270.5 297.3,270.5 293.6,270.5  292.7,270.5 214.1,270.5 214.1,285.9 228,285.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M748.5,285.9h-13.9l4.7,47.6h-36.5c-0.5,4.6-0.8,9.3-1.2,14h39l21.1,214.4h13.9L748.5,285.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "620.6,425.5 632.9,549 647.2,553.5 634.5,425.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M337.2,333.5H223.4l4.7-47.6h-13.9L187,561.8h13.8l21.1-214.4h113.8l-20.4,207.1c0.4-0.4,0.8-0.7,1.3-1 l13.1-3.7l26-263.9h-13.9L337.2,333.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M509.8,556.5l59.4-18.6l-1.1-5.4l-21.1-3l-12.5,12.2l-39,11.9c-5.4,3.8-3.7,8.3-3.7,8.3h10.3 C502.6,557.3,509.8,556.5,509.8,556.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M572.8,518.5l-20.7-93h-59.7l1.3,3.4c0,0,0,0,0.1,0c0.5-0.1,0.8,0.1,1,0.5c3.8,13.4,8.9,23.5,11.2,31 c2.3,7.9,5.9,15.8,8.8,23.6c4.5,12.1,7.7,22.9,13.9,38.8c0.2,0.4-0.1,0.8-0.5,1l0,0l1.9,5.3c0,0,6.9-0.2,16.1-1.9 c6.1-1.1,13.1-2.9,19.9-5.7C568.4,520.8,570.7,519.7,572.8,518.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M358.6,541.6l-28.9,8.2l-13.1,3.7c-0.5,0.4-0.9,0.7-1.3,1c-3.9,3.5-2.4,7.3-2.4,7.3h1.7h13.9h69.6l-5.8-29.4 l-21.1-3L358.6,541.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M433.3,333.1c-7.4,2.6-12.3,7.1-15.5,11.3C421.8,339.6,426.9,335.6,433.3,333.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M562.4,335.1c-5.8-0.3-29.3-2-35.7-9.5l0,0l-19.3,1.3c0,0,0,0,0,0.1c0,0.5-0.4,0.8-0.8,0.8 c-14.9,0-44.9,2.9-59.6,4c-13.2,1-21.9,6.1-28.1,13.8c-3.4,4.4-6.2,9.5-8.5,15.2l-2.4,6.7c-0.8,2.5-1.6,5.2-2.4,7.8 c-4.5,16-11,31.3-17,46.7c-4.6,11.6-11.2,32.1-19,53.2c-0.2,0.4-0.6,0.6-1,0.5l-13.8,37.8c0,0,7.1,5,17.2,9.7 c6.2,2.8,13.4,5.5,20.9,6.9c0.9,0.2,1.7,0.3,2.6,0.5L470.6,392h5.6c1.8-1.1,3.9-1.7,6.2-1.7h80.5c8.7-11.7,10.5-33.3,12.3-47.4 c0.1-0.7,0.1-1.5,0.2-2.2C572,337.6,567.9,335.4,562.4,335.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M620.2,70.1c-0.1-7.4-1.1-23.1-12-25.6c-2.8-9.3-20.5-4.7-20.5-4.7c-30.1,4.2-40.9-2.4-40.9-2.4 c-5.3,15.8,5.3,18.5,5.3,18.5c-4,0-9.5-0.5-9.5-0.5c1.3,7.5,9.8,10.5,16.3,11.7c4.3,0.8,7.8,0.8,7.8,0.8l7.1,15.3 c0.1,0.4,0.2,0.6,0.3,0.9c0-0.7-0.1-1.5,0-2.2c0.2,0.6,0.5,1.4,0.7,2.3c0.1-0.2,0.1-0.3,0.2-0.5c-0.9-3.4-0.9-7.3,1.7-10 c0.7-0.7,1.6-1.2,2.6-1.4c0.3-0.2,0.6-0.4,1-0.5c2.8-0.7,5.1,0.5,6.7,2.5c0.6,0.5,1.2,1.1,1.5,1.6c2.3,3.7,2.3,9.2-0.9,13.1 c-0.6,0.8-1.3,1.4-2,1.8c0,0.1,0.1,0.2,0.1,0.3c0.6,0,1.3,0.2,1.8,0.8c1.5,1.6,2,3.7,2.5,5.8c1.1,4.4,3.1,7.3,4.7,11.5 c1.9,3.2,13.5,2.3,20.2-0.2c6.3-2.4,5.3-8.7,5.3-10.8C620.2,83.9,620.4,86.9,620.2,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M584.4,86.7c-0.2-0.1-0.5-0.2-0.6-0.3c-1.1-0.5-2-1.5-2.6-2.7c-0.3-0.5-0.5-1.1-0.7-1.7 c-0.2,0.2-0.5,0.3-0.8,0.2c-0.4-0.2-0.5-0.6-0.4-1c0.2-0.5,0.5-0.8,0.8-1.1c0-0.4-0.1-0.6-0.1-1c0-0.5,0.1-1.1,0.2-1.5 c0.1-0.3,0.2-0.5,0.3-0.7c0.2-0.4,0.1-0.8-0.4-1.1c-0.4-0.2-0.8-0.1-1.1,0.4c-0.5,0.8-0.6,1.8-0.6,2.9c0,1.7,0.5,3.7,1.4,5.4 c0.9,1.7,2.4,3.2,4.3,3.7c0.5,0.1,0.8-0.1,1-0.5C585.1,87.2,584.9,86.9,584.4,86.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M580,80c-0.4,0.3-0.6,0.6-0.8,1.1c-0.2,0.4,0,0.8,0.4,1c0.3,0.1,0.6,0.1,0.8-0.2c0.1-0.1,0.2-0.2,0.2-0.3 c0.2-0.4,0.5-0.6,0.8-0.9c0.2-0.1,0.4-0.3,0.5-0.4c0.7-0.4,1.5-0.6,2.2-0.7c0.5-0.1,0.7-0.5,0.6-0.9c-0.1-0.5-0.5-0.7-0.9-0.6 c-0.8,0.2-1.7,0.5-2.6,0.9c-0.2,0.1-0.3,0.2-0.5,0.3C580.5,79.5,580.3,79.7,580,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M584.3,134.9c13.5,0,27.5-0.4,39.3-6.3c0.4-0.2,0.5-0.6,0.4-1.1c-0.2-0.4-0.6-0.5-1.1-0.4 c-11.3,5.8-25.1,6.2-38.5,6.2c-0.5,0-0.8,0.4-0.8,0.8C583.5,134.6,583.8,134.9,584.3,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M569.6,201.9c0.1-0.1,0.3-0.2,0.4-0.4c0.4-0.4,0.7-0.6,1.2-1c0.3-2.5,0.4-5.1,0.4-7.6c0-0.7,0-1.4-0.1-2.1 c-0.1-4.2-0.6-8.3-1.5-11.8c-1-3.6-3.2-9.2-6.3-14.1c-0.2-0.3-0.4-0.5-0.5-0.9c-1.5-2.1-3-4.1-4.7-5.6c-2-1.8-4.2-3.1-6.5-3.4 c-0.5-0.1-0.8,0.2-0.9,0.6c-0.1,0.5,0.2,0.8,0.6,0.9c2,0.3,3.9,1.5,5.7,3.1c1,0.9,2,2,2.9,3.2c4.1,5.3,7.2,12.4,8.3,16.6 c1.1,3.9,1.5,8.6,1.5,13.4l0,0c0,3-0.2,6.1-0.5,9.1C569.4,202,569.5,201.9,569.6,201.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M666.3,154.7c0,5.1,0.2,10.1,0.2,15.1v0.1l0,0c0,1.4,0,2.7,0,4.2c0,4.7-0.2,9.5-1.9,13.7 c-0.3,0.8-0.6,1.5-0.9,2.2c0.5,0,1.1,0.1,1.6,0.1c0.3-0.5,0.5-1.1,0.7-1.7c1.8-4.6,2.1-9.5,2.1-14.3c0-1.4,0-2.8,0-4.2l0,0l0,0l0,0 c0-5.2-0.2-10.2-0.2-15.1c0-2.1,0-4.1,0.1-6.2c0-0.5,0-0.9,0.1-1.4c0-0.5-0.3-0.8-0.7-0.8c-0.5,0-0.8,0.3-0.8,0.7v0.1 C666.3,149.7,666.3,152.3,666.3,154.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M681.2,178.1c-1.5-5.9-4.7-16-9.5-23.1c-0.9-2.5-2.2-4.8-3.7-6.4c-0.1,2.1-0.1,4.1-0.1,6.2 c0,5,0.2,10,0.2,15.1l0,0l0,0l0,0c0,1.4,0,2.7,0,4.2c0,4.8-0.2,9.7-2.1,14.3c-0.3,0.6-0.5,1.2-0.7,1.7c2.4,0.1,4.8,0.3,7.2,0.5 c1.3,0.1,2.6,0.2,3.9,0.3c2.1,0.2,4.3,0.3,6.4,0.5C682.6,186.8,682.3,182.4,681.2,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M565.2,255.4c-0.7,2.4-1.5,4.7-2.3,7.1c-1.7,5.4-2.6,11.2-4.5,16.8c-1.8,5.2-5.7,11.1-9.7,14.9 c0,0-0.1,0-0.1,0.1c0.1,4.4-1.8,9.2-3.6,13.1c-1.5,3.4-3.5,6.8-6,9.8c-1.6,2.1-13.8,6.6-12.2,8.5l0,0c6.3,7.5,29.9,9.2,35.7,9.5 c5.5,0.3,9.5,2.4,13,5.6c1.8-17,0.3-35.8-2.6-52.3C570.8,276.9,568.6,266.3,565.2,255.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M666.5,170L666.5,170L666.5,170c0-5.2-0.2-10.2-0.2-15.2c0-2.4,0-5,0.2-7.5c-0.3-0.2-0.6-0.4-0.9-0.5 l-46.7-24.9l0,0c-4.6,0-14.1,2-18.9,3c-4.4,0.9-10.4,0.8-14.4,3.4c-0.2,0.1-0.5,0.3-0.6,0.4c-3.6,2.8-8.3,6.5-14.3,11.6 c-4.4,3.8-21.3,15.9-26.3,19.2c-9.6,7-17.4,28.2-18.8,40.8c-1.5,13.4-4.4,29.9-6.3,46.4c-0.1,0.5-0.1,0.9-0.2,1.5 c2.6-0.4,5-0.5,7.3-0.5c3,0,5.7,0.3,8.3,0.5c0.5,0.1,0.7,0.5,0.6,0.9c-0.1,0.5-0.5,0.7-0.9,0.6c-2.4-0.3-5.1-0.5-8.1-0.5 c-0.9,0-1.8,0-2.7,0.1c-4,0.2-8.5,0.9-13.8,2.6c-0.4,0.1-0.7-0.1-0.9-0.4c-0.1,0.1-0.2,0.1-0.3,0.1c-3.9,2-7.8,3.6-11.7,4.9 c-4.7,1.5-9.3,2.6-13.7,3.4c-13.5,2.2-24.8,1-30.5,0c-2.4-0.5-3.8-0.8-3.8-0.8l-33.2,0.5l0,0c0,0,0.2,3.6,1.5,12.9 c0.3,1.8,0.5,3.8,0.8,6c0.4,2.8,2.8,5.3,6.2,7.7c6.8,4.6,17.7,8.2,24.9,10.1c24.4,6.5,51,9,75.6,8.9c10.3-0.1,17-1.9,22.7-10.6 c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.3-0.3-0.8,0-1.1c0.8-0.7,1.5-1.5,2.4-2.4c3-3.4,5.6-7.9,7-11.8c1.9-5.3,2.7-11.2,4.5-16.8 c1-3.1,2-6.2,3-9.2c-0.1-0.3-0.2-0.5-0.3-0.9c-4.2-12.6-6.4-25.4-2.2-38.1c0.3-0.8,0.5-1.5,0.9-2.3c0.1-0.3,0.2-0.5,0.3-0.7 c0.2-0.5,0.5-1,0.7-1.5c0.1-0.3,0.3-0.5,0.5-0.7c0.3-0.5,0.5-0.8,0.7-1.2c0.2-0.3,0.3-0.5,0.5-0.7c0.3-0.4,0.5-0.7,0.8-1.1 c0.2-0.2,0.4-0.5,0.5-0.6c0.3-0.4,0.6-0.7,1-1.1c0.2-0.2,0.3-0.4,0.5-0.5c0.5-0.5,0.8-0.8,1.3-1.3c0.4-3,0.5-6,0.5-9.1l0,0 c0-4.8-0.5-9.5-1.5-13.4c-1.1-4.2-4.2-11.4-8.3-16.6c-0.9-1.2-1.9-2.3-2.9-3.2c-1.8-1.6-3.8-2.7-5.7-3.1c-0.5-0.1-0.7-0.5-0.6-0.9 c0.1-0.5,0.5-0.7,0.9-0.6c2.4,0.4,4.5,1.6,6.5,3.4c1.7,1.5,3.4,3.5,4.7,5.6c0.2,0.3,0.4,0.5,0.5,0.9c3.1,4.9,5.3,10.4,6.3,14.1 c0.9,3.5,1.5,7.6,1.5,11.8c0,0.7,0.1,1.4,0.1,2.1c0,2.5-0.2,5.1-0.4,7.6c0,0,0,0,0.1,0c0.2-0.2,0.5-0.3,0.6-0.5 c0.4-0.3,0.7-0.5,1-0.7c0.3-0.2,0.5-0.3,0.7-0.5c0.4-0.2,0.7-0.5,1.1-0.6c0.3-0.2,0.5-0.3,0.7-0.5c0.4-0.2,0.7-0.4,1.1-0.5 c0.3-0.1,0.5-0.3,0.7-0.4c0.5-0.2,0.9-0.4,1.4-0.5c0.2-0.1,0.4-0.2,0.6-0.3c0.6-0.3,1.3-0.5,2-0.7c0.3-0.1,0.5-0.2,0.7-0.3 c0.5-0.2,0.9-0.3,1.4-0.5c0.3-0.1,0.6-0.2,0.9-0.3c0.3-0.1,0.5-0.2,0.8-0.2l0,0c1.9-0.5,3.8-0.9,5.8-1.3c10.3-1.9,20.9-3,31.6-3.4 c13.8-0.5,27.6-0.3,41.3,0.5c0.3-0.7,0.6-1.4,0.9-2.2c1.7-4.3,1.9-9,1.9-13.7C666.5,172.7,666.5,171.4,666.5,170z M584.3,133.4 c13.4,0,27.2-0.4,38.5-6.2c0.4-0.2,0.8,0,1.1,0.4c0.2,0.4,0,0.8-0.4,1.1c-11.8,6-25.8,6.3-39.3,6.3c-0.5,0-0.8-0.4-0.8-0.8 C583.5,133.8,583.8,133.4,584.3,133.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M556.9,278.7c-1.4,3.9-4.1,8.3-7,11.8c-0.7,0.9-1.5,1.7-2.4,2.4c-0.3,0.3-0.4,0.8,0,1.1 c0.1,0.1,0.1,0.1,0.2,0.1c0.3,0.2,0.5,0.1,0.8,0c0,0,0.1,0,0.1-0.1c4.1-3.7,7.9-9.6,9.7-14.9c2-5.6,2.8-11.3,4.5-16.8 c0.7-2.4,1.5-4.7,2.3-7.1c-0.3-0.9-0.5-1.7-0.8-2.6c-1,3.1-2,6.1-3,9.2C559.7,267.6,558.8,273.3,556.9,278.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M508.9,251.1C508.9,251.1,508.9,251.2,508.9,251.1c0.3,0.5,0.6,0.6,1,0.5c5.2-1.7,9.7-2.4,13.8-2.6 c0.9-0.1,1.8-0.1,2.7-0.1c2.9,0,5.5,0.3,8.1,0.5c0.5,0.1,0.8-0.3,0.9-0.6c0.1-0.5-0.3-0.8-0.6-0.9c-2.5-0.3-5.3-0.5-8.3-0.5 c-2.3,0-4.6,0.2-7.3,0.5c-1.5,0.2-3.2,0.5-4.8,0.9c-1.5,0.4-3.2,0.8-4.9,1.4C509,250.2,508.8,250.6,508.9,251.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M709.1,202.5c-6-8.1-16.5-10.2-26.3-11.2c-2.2-0.2-4.4-0.4-6.4-0.5c-1.3-0.1-2.6-0.2-3.9-0.3 c-2.4-0.2-4.8-0.3-7.2-0.5c-0.5,0-1.1-0.1-1.6-0.1c-13.8-0.7-27.6-1.1-41.3-0.5c-10.5,0.5-21.1,1.5-31.6,3.4 c-2,0.4-3.9,0.8-5.8,1.3c9.9,6.5,13.1,20.2,14.8,31.2c3.3,21.4,2.3,43.2,2.5,64.7c0,0-0.5,65-12.2,100.1h-27.2h-80.5 c-2.3,0-4.4,0.6-6.2,1.7c-3.4,2.1-5.6,5.8-5.6,10v11.6c0,6.4,5.3,11.7,11.7,11.7h10.2h59.7h23.4h7.6h7.6h29.8h13.9h51.6 c6.4,0,11.7-5.3,11.7-11.7c2.7-13.2,1.9-37.3,2.6-50c0.4-5.4,0.7-10.9,1.1-16.3c0.4-4.6,0.7-9.3,1.2-14c1.5-15.9,3.1-31.7,4.8-47.6 c0.5-5.1,1.1-10.2,1.6-15.3c0.8-7.8,1.6-15.7,2.4-23.5C712.8,232.9,718.4,215.1,709.1,202.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M599.8,225.4c-1.7-11-4.9-24.7-14.8-31.2l0,0c-0.3,0.1-0.5,0.2-0.8,0.2c-0.3,0.1-0.6,0.2-0.9,0.3 c-0.5,0.1-0.9,0.3-1.4,0.5c-0.3,0.1-0.5,0.2-0.7,0.3c-0.6,0.3-1.4,0.5-2,0.7c-0.2,0.1-0.4,0.2-0.6,0.3c-0.5,0.2-0.9,0.4-1.4,0.5 c-0.3,0.1-0.5,0.3-0.7,0.4c-0.4,0.2-0.7,0.4-1.1,0.5c-0.3,0.2-0.5,0.3-0.7,0.5c-0.4,0.2-0.7,0.5-1.1,0.6c-0.3,0.2-0.5,0.3-0.7,0.5 c-0.4,0.3-0.7,0.5-1,0.7c-0.2,0.2-0.5,0.3-0.6,0.5c0,0,0,0-0.1,0c-0.4,0.3-0.8,0.6-1.2,1c-0.1,0.1-0.3,0.2-0.4,0.4 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.5,0.4-0.8,0.8-1.3,1.3c-0.2,0.2-0.3,0.4-0.5,0.5c-0.4,0.4-0.6,0.7-1,1.1c-0.2,0.2-0.4,0.5-0.5,0.6 c-0.3,0.4-0.5,0.7-0.8,1.1c-0.2,0.3-0.3,0.5-0.5,0.7c-0.3,0.4-0.5,0.8-0.7,1.2c-0.2,0.3-0.3,0.5-0.5,0.7c-0.3,0.5-0.5,0.9-0.7,1.5 c-0.1,0.3-0.2,0.5-0.3,0.7c-0.3,0.7-0.6,1.5-0.9,2.3c-4.3,12.7-2,25.5,2.2,38.1c0.1,0.3,0.2,0.5,0.3,0.9c0.3,0.9,0.5,1.7,0.8,2.6 c3.4,11,5.6,21.6,7.6,33.1c2.9,16.5,4.4,35.4,2.6,52.3c-0.1,0.7-0.1,1.5-0.2,2.2c-1.8,14.2-3.6,35.7-12.3,47.4h27.2 c11.7-35.1,12.2-100.1,12.2-100.1C601.9,268.7,603,246.8,599.8,225.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "583.9,535.9 590.8,535.9 590.8,425.5 583.2,425.5 583.2,535.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "582.5,535.9 583.2,535.9 583.2,425.5 575.7,425.5 575.7,535.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "591,535.9 590.8,535.9 656.6,556.5 647.2,553.5 632.9,549  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M582,543.9l8.8-8h-6.9h-0.6l-30.4,25.8h21h8.6h1.4h50.2H648h16.4c-0.5-4.4-7.8-5.3-7.8-5.3L582,543.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M583.2,535.9h-0.6h-6.9h-0.2l-6.3,2l-59.4,18.6c0,0-7.3,0.8-7.8,5.3h50.9L583.2,535.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "590.8,535.9 582,543.9 656.6,556.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M546.2,527.4l0.7,2.1l21.1,3l-2-10.7C559.3,524.5,552.3,526.3,546.2,527.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M371.2,529.5l21.1,3l0.6-2.3c-7.4-1.4-14.7-4.1-20.9-6.9L371.2,529.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M585.6,91.2c0-0.1-0.1-0.2-0.1-0.3c0.6-0.5,1.4-1,2-1.8c3.1-3.8,3.2-9.4,0.9-13.1c-0.4-0.5-0.9-1.2-1.5-1.6 c-1.6-2.1-3.9-3.4-6.7-2.5c-0.4,0.1-0.7,0.3-1,0.5c-0.9,0.2-1.8,0.6-2.6,1.4c-2.7,2.6-2.6,6.6-1.7,10c-0.1,0.2-0.1,0.4-0.2,0.5 c1.1,3.9,2.7,9.4,6.6,8.7c0.9-0.2,1.8-0.7,2.7-1.2c0.3-0.1,0.5-0.3,0.8-0.4C585.2,91.2,585.4,91.2,585.6,91.2z M584,88.2 c-1.9-0.5-3.4-2.1-4.3-3.7c-0.9-1.7-1.4-3.7-1.4-5.4c0-1.1,0.2-2.1,0.6-2.9c0.2-0.4,0.6-0.5,1.1-0.4c0.4,0.2,0.5,0.6,0.4,1.1 c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.5-0.2,0.9-0.2,1.5c0,0.3,0,0.6,0.1,1c0.3-0.3,0.5-0.5,0.8-0.6c0.2-0.1,0.3-0.2,0.5-0.3 c0.9-0.5,1.8-0.7,2.6-0.9c0.5-0.1,0.8,0.2,0.9,0.6s-0.2,0.8-0.6,0.9c-0.6,0.1-1.5,0.4-2.2,0.7c-0.2,0.1-0.4,0.3-0.5,0.4 c-0.4,0.3-0.7,0.6-0.8,0.9c0,0.1-0.1,0.2-0.2,0.3c0.2,0.6,0.5,1.2,0.7,1.7c0.6,1.3,1.5,2.2,2.6,2.7c0.2,0.1,0.5,0.2,0.6,0.3 c0.5,0.1,0.6,0.5,0.5,1C584.9,88.1,584.4,88.3,584,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M574,84.1c-0.1-0.2-0.2-0.5-0.3-0.9l-7.1-15.3c0,0-3.4,0-7.8-0.8c-0.1,1-0.2,1.9-0.2,2.9 c0,0.5,0,0.9,0.1,1.4c0.1,1,0.1,4.2,0.2,5.2l2.2,4.9c0.5,3.2-4.8,14.9-4.8,14.9c0.2,2.1,5.3,1.3,7.2,2.4c0,0,0,0,0-0.1 c2.5-1.2,4.8-2,7.5-1.8c1.8,0.1,3.6,0.6,4.6-1.3c1.1-2-0.1-4.7-0.7-6.6C574.5,87.2,574.1,85.7,574,84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M614.9,109.1c-6.7,2.4-18.2,3.4-20.2,0.2c-2.3,3.3-7,7.9-10.2,10.9l1.2,7.8c3.9-2.5,10-2.4,14.4-3.4 c4.8-1,14.2-2.9,18.9-3L614.9,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M413.5,259l-10-2.8l-1.1-0.3l-0.8-0.3l-4.1-1.2l-1.3,0.5l-4.6,1.6l-5.6,2l-2.2,0.8l-12.3,4.4 c0,0-3.6,0.4-6.1,2.2c-1.5,1-2.4,2.5-2.3,4.6h15.4h8H415c0.8,0.5,1.7,1.1,2.5,1.6c-1.2-9.2-1.5-12.9-1.5-12.9 C414.4,259.2,413.5,259,413.5,259z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M590,97.8c-0.5-2-1-4.2-2.5-5.8c-0.6-0.6-1.3-0.9-1.8-0.8c-0.3,0-0.5,0.1-0.7,0.2c-0.3,0.1-0.5,0.2-0.8,0.4 c-0.9,0.5-1.8,1-2.7,1.2c-3.9,0.7-5.5-4.8-6.6-8.7c-0.3-0.9-0.5-1.6-0.7-2.3c-0.1,0.7,0,1.5,0,2.2c0.1,1.6,0.4,3.2,0.9,4.9 c0.6,1.9,1.8,4.7,0.7,6.6c-1,1.9-2.8,1.4-4.6,1.3c-2.8-0.2-5.1,0.6-7.5,1.8v0.1c1.1,7.8,1.5,17.1,6.6,23.6c3.2,4,7.3,3.1,11.2,0.7 c0,0,1.4-1.2,3.2-2.8c3.2-3,8-7.6,10.2-10.9C593.2,105,591.1,102.2,590,97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M506.6,326.2c-15.1,0-45,2.9-59.8,4c-5.2,0.4-9.7,1.4-13.6,2.9c-6.4,2.5-11.5,6.4-15.5,11.3l0,0 c-6.4,8-10.3,18.6-13.6,30.4c-4.4,15.9-10.9,31.1-17,46.5c-4.6,11.7-11.3,32.2-19,53.3c-0.2,0.4,0.1,0.8,0.5,1l0,0 c0.4,0.2,0.8-0.1,1-0.5c7.7-21.2,14.4-41.7,19-53.2c6.1-15.3,12.5-30.6,17-46.7c0.7-2.7,1.5-5.3,2.4-7.8c0.7-2.4,1.5-4.5,2.4-6.7 c2.3-5.8,5-11,8.5-15.2c6.3-7.7,14.9-12.8,28.1-13.8c14.7-1.1,44.7-4,59.6-4c0.5,0,0.8-0.4,0.8-0.8c0,0,0,0,0-0.1 C507.4,326.5,507.1,326.2,506.6,326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M528.6,522.9c-6.2-16-9.3-26.7-13.9-38.8c-2.9-7.8-6.5-15.7-8.8-23.6c-2.2-7.5-7.3-17.7-11.2-31 c-0.1-0.5-0.5-0.6-1-0.5c0,0,0,0-0.1,0c-0.4,0.2-0.6,0.5-0.5,0.9c3.9,13.5,9,23.8,11.2,31c2.4,8.1,6,16,8.8,23.7 c4.4,12.1,7.7,22.9,13.9,38.8c0.2,0.4,0.6,0.6,1,0.5l0,0C528.6,523.7,528.8,523.3,528.6,522.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsADeveloper01);
export default __webpack_public_path__ + "static/media/as_a_developer-01.70308f01e0d8cacea0a2581d52fbbbf3.svg";
export { ForwardRef as ReactComponent };